import { isNotDefined } from '@enterprise/core';

/**
 * Parses an array of string items, expanding any numeric ranges (e.g., "1-3")
 * into their constituent numbers as strings.
 *
 * - If an item matches the pattern for a numeric range (e.g., "2-5"), it will be
 *   expanded into individual numbers ("2", "3", "4", "5").
 * - Non-range items are included as-is after trimming whitespace.
 * - Duplicate values are removed in the returned array.
 * - Items that are undefined or null are skipped.
 *
 * @param items - An array of strings, which may include numeric ranges (e.g., "1-3") or individual values.
 * @returns An array of unique string values, with numeric ranges expanded.
 */
export const parseNumericRange = (items: string[]) => {
  const options: string[] = [];
  const { length } = items;

  for (let i = 0; i < length; i++) {
    const item = items[i];

    if (isNotDefined(item)) {
      continue;
    }

    const value = item.trim();

    if (/[0-9]{1,}\s{0,}-\s{0,}[0-9]{1,}/.test(value)) {
      const [low = 0, high = 0] = value.split('-').map((item) => {
        return Number.parseInt(item.trim(), 10);
      });

      options.push(
        ...Array.from({ length: high - low + 1 }, (_, num) => {
          return `${low + num}`;
        })
      );
    } else {
      options.push(value);
    }
  }

  return [...new Set(options)];
};
